import { fetchPublicUserProfile } from "@shared/services/publicUserProfilesService";
import { useQuery } from "@tanstack/react-query";
import { userQueryKeys } from "../queryKeys";

/**
 * Fetches a public user profile by uid (peer reads via Cloud Function).
 * For the signed-in user's own full document, use useCurrentUser instead.
 */
export function useUser(uid: string | undefined) {
  return useQuery({
    queryKey: userQueryKeys.user(uid ?? ""),
    queryFn: () => fetchPublicUserProfile(uid ?? ""),
    enabled: !!uid,
  });
}
